export default class Nav {
	toggle_mobile() {
		$($('.navtop-mobile')[0]).toggle(300)
	}
}
